import $ from 'jquery';
import React,{useState,useEffect} from 'react';
import {GetImgCertUser_CBack,btnSetColor_CBack,TableDatePicker} from '../function_lib/common_lib';

export function updAddDeductBalance(){
    GetImgCertUser_CBack(this,"#frmAddDeductBalance","addDeductBalance",function(checkData,checkMsg,userMsg){
      if(checkData===-10){
        alert("Kindly fill required fields");
        return;
      }else {
        //Custom_Alert("Successfully Added",checkMsg,false);
        alert(checkMsg);
        $('#divAddDeductBalance').modal('hide');
        window.location.reload();
      }
    });
}             
  
export const Comp_Add_Deduct_Balance=(props)=>{
    
    useEffect(()=>{
        //setMyProfile(props.memberProfile);
    },[props.memberProfile])

    //alert(JSON.stringify(props));
        return(<div className="modal fade bd-example-modal-xl"  id="divAddDeductBalance" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">Add / Deduct Balance</h5>
              <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
            <div className="modal-body">
            {props.memberProfile.length>0?
            <form enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()" className="contact-form-style form-control11 " name="frmAddDeductBalance" id="frmAddDeductBalance">
    <input type="hidden" name="curl_type" id="curl_type" value="addDeductBalance" />  
                <input type="hidden" name="m_type" id="m_type" value="addDeductBalance" />
                <input type="hidden" name="res_func" id="res_func" value="okSuccCont" />
                <input type="hidden" name="account_info_id" id="account_info_id"  value={btoa(props.memberProfile[0]["account_info_id"])}/>
                <input type='hidden' name="member_token" id="member_token" value={btoa(props.memberProfile[0]["id"])}/>
                <input type="hidden" name="created_by" id="created_by" value={props.logInObj[0]["id"]}/>
        {/* uneditable Information */}
        <div class="row">
        <div class="col-md-4 form-group pl-2 pr-2 mb-4">
                <label class="float-left">Member ID:<strong> {props.memberProfile[0]["id"]}</strong> </label>
                
            </div>
        <div class="col-md-4 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Company Name: {props.memberProfile[0]["company_name"]}</strong></label>
            </div>

            <div class="col-md-4 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Person Name: {props.memberProfile[0]["person_name"]}</strong></label>
            </div>

            <div class="col-md-4 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Contact No:</strong> {props.memberProfile[0]["contact_no"]}</label>
            </div>
            <div class="col-md-4 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Email-Id:</strong> {props.memberProfile[0]["email_id"]}</label>
            </div>

            <div class="col-md-4 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Available Balance:</strong> {props.memberProfile[0]["email_id"]}</label>
            </div>

        </div>
        <h4 class="mt-4">Add/Deduct balance</h4>
        <div class="row">
           
            <div class="col-md-3 col-sm-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Transaction:</strong></label>
                <select className='form-control required' id="trans_type" name="trans_type">
                    <option value={"0"}>-Transaction-</option>
                    <option value={"Add"}>Add</option>
                    <option value={"Deduct"}>Deduct</option>
                </select>
            </div>
            <div class="col-md-3 col-sm-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Balance Amount:</strong></label>
                <select className='form-control required' id="balance" name="balance">
                    <option value={"0"}>-Transaction-</option>
                    <option value={"499"}>499 /- </option>
                    <option value={"999"}>999 /-</option>
                    <option value={"1499"}>1499 /-</option>
                    <option value={"1999"}>1999 /-</option>
                    <option value={"2499"}>2499 /-</option>
                    <option value={"3499"}>3499 /-</option>
                </select>

                
            </div>
            <div class="col-md-3 col-sm-6 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Payment Mode:</strong></label>
                <select className='form-control required' id="payment_mode" name="payment_mode">
                    <option value={"0"}>-Select-</option>
                    <option value={"Admin Ref"}>-Admin Ref-</option>
                    <option value={"Cash"}>-Cash-</option>
                    <option value={"Net Banking"}>-Net Banking-</option>
                    <option value={"UPI"}>-UPI-</option>
                   
                </select>
                
            </div>
           
        </div>
    
        <div class="form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>Narration (Remarks*):</strong></label>
            <input name="narration" defaultValue={props.memberProfile[0]["narration"]} id="narration" type="text" class="form-control required" placeholder="Narration" required/>
        </div>

        <div class="form-group pl-2 pr-2 mb-4">
            <label class="float-left"><strong>UTR/Transaction-Id (if Any):</strong></label>
            <input name="utr_trans_id" id="utr_trans_id" defaultValue={props.memberProfile[0]["utr_trans_id"]} type="text" class="form-control required" placeholder="Enter occupation"/>
        </div>
       
        <div class="text-center mt-4">
            <button type="button" onClick={()=>updAddDeductBalance()} class="btn btn-primary me-2">Update</button>
            {/* <button type="reset" class="btn btn-secondary">Reset</button> */}
        </div>
    </form>:''}
          </div>
          </div>
          </div>
          </div>);
    
}
export default Comp_Add_Deduct_Balance;
